import type { GResponse } from "../../models/common.ts";
import type { Vendor } from "../../models/contador.ts";
import type { VendorsSearchRequest } from "../../models/search";
import { fetchFromContador } from "./contador-fetch.ts";

export async function searchVendorsV2(
    payload: VendorsSearchRequest,
): Promise<GResponse<Vendor> | undefined> {
    try {
        return await fetchFromContador<GResponse<Vendor>>("/api/v2/vendors/search", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
    } catch (e) {
        console.error(e);
        return undefined;
    }
}
